import React from 'react';
import { connect } from 'react-redux';
import { gridSpacing } from 'store/constant';
import { Grid, Paper } from '@mui/material';
import SearchBar from 'components/Dashboard/SearchBar';
import LoaderCustom from 'ui-component/LoaderCustom';
import StateReportSkanView from '../components/StateReport/StateReportSkanView';
import StateReportNonSkanView from 'components/StateReport/StateReportNonSkanView';

const StateReportPage = ({ advertiserList, isSkan, timeZone }) => {
  return (
    <>
      {advertiserList.length === 0 ? (
        <LoaderCustom />
      ) : (
        <>
          <Paper elevation spacing={gridSpacing} className="stickyBox">
            <SearchBar />
          </Paper>
          <Grid container spacing={gridSpacing}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={gridSpacing}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  {timeZone === 'JST' ? <StateReportNonSkanView /> : isSkan === true ? <StateReportSkanView /> : <StateReportNonSkanView />}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.creativeReducer.creativeLoading,
  advertiserList: state.advertiserReducer.advertiser_list,
  isSkan: state.campaignReducer.isSkan,
  timeZone: state.advertiserReducer.timeZone
});

export default connect(mapStateToProps, null)(StateReportPage);
